export const CURRENT_USER_LOADING = 'CURRENT_USER_LOADING';
export const CURRENT_USER_LOADED = 'CURRENT_USER_LOADED';
export const CURRENT_USER_ERROR = 'CURRENT_USER_ERROR';
